import TextFieldMui from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

export const TextField = styled(TextFieldMui, { label: 'AutocompleteTextField' })(() => ({
  '& .MuiInputBase-input': {
    unicodeBidi: 'plaintext',
    textAlign: 'left',
  },
}));
